"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_boost_1 = require("apollo-boost");
var defaultWalkthroughFragment_1 = __importDefault(require("./defaultWalkthroughFragment"));
var GetWalkthroughsById = (0, apollo_boost_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getWalkthroughsById($ids: [VersionId]!) {\n    getWalkthroughsById(ids: $ids) {\n      ...ResponseFields\n    }\n  }\n  ", "\n"], ["\n  query getWalkthroughsById($ids: [VersionId]!) {\n    getWalkthroughsById(ids: $ids) {\n      ...ResponseFields\n    }\n  }\n  ", "\n"])), defaultWalkthroughFragment_1.default);
exports.default = GetWalkthroughsById;
var templateObject_1;
